<template>
	<div>
		<el-dialog :visible.sync="dialogFlag" @close="gbBtn" :width="wid" :before-close="gbBtn" :close-on-click-modal="false">
			<span slot="title">
				<p class="header-main-title">{{ title }}</p>
				<p class="msP" v-show="msflag">修改归属学校请先删除关联的班级</p>
			</span>
			<slot></slot>
			<slot name="footer">
				<div slot="footer" class="dialog-footer" :style="{ background: lefBg }">
					<div class="loadBtn" @click="gbBtn">
						{{ lefTxt }}
					</div>
					<div class="loadBtn loadBtnQr" :style="{ background: rigBg }" @click="qrsFn">
						{{ rigTxt }}
					</div>
				</div>
			</slot>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'dialogBox',
	data() {
		return {};
	},
	props: {
		msflag: {
			type: Boolean,
			default: false
		},
		dialogFlag: {
			type: Boolean,
			default: false
		},
		wid: {
			type: String,
			default: '477px'
		},
		title: {
			type: String,
			default: '修改'
		},
		rigTxt: {
			type: String,
			default: '确认'
		},
		rigBg: {
			type: String,
			default: ''
		},
		lefTxt: {
			type: String,
			default: '取消'
		},
		lefBg: {
			type: String,
			default: ''
		}
	},
	methods: {
		gbBtn() {
			this.$emit('callFn', false);
		},
		qrsFn() {
			this.$emit('qrsFn');
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.msP {
	text-align: center;
	font-size: 14px;
	color: #666666;
	margin: 8px 0 0;
}
.dialog-footer {
	display: flex;
	justify-content: center;
	padding-bottom: 10px;

	.loadBtn {
		width: 88px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #ffffff;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		border: 1px solid #d8e0f0;
		font-size: 16px;
		color: #000000;
		border-radius: 6px;
		cursor: pointer;
	}
	.loadBtnQr {
		background: #1d7b3a;
		color: #ffffff;
		margin-left: 25px;
	}
}
.header-main-title {
	font-size: 22px;
	color: #000000;
	text-align: center;
	line-height: 30px;
	padding-top: 30px;
}
</style>
